export function fmtMoney(amount, currency, opts = {}) {
  const n = Number(amount || 0);
  if (currency === "INR") {
    return "₹" + n.toLocaleString("en-IN", { minimumFractionDigits: 2, maximumFractionDigits: 2 });
  }
  const s = n.toLocaleString("en-US", { minimumFractionDigits: 2, maximumFractionDigits: 4 });
  return opts.noUnit ? s : `${s} USDT`;
}

export function fmtDate(iso, withTime = true) {
  if (!iso) return "—";
  const d = new Date(iso);
  return d.toLocaleString("en-IN", {
    day: "2-digit", month: "short", year: "numeric",
    ...(withTime ? { hour: "2-digit", minute: "2-digit" } : {}),
  });
}

export function timeAgo(iso) {
  if (!iso) return "";
  const s = Math.floor((Date.now() - new Date(iso).getTime()) / 1000);
  if (s < 60) return "just now";
  if (s < 3600) return `${Math.floor(s / 60)}m ago`;
  if (s < 86400) return `${Math.floor(s / 3600)}h ago`;
  return `${Math.floor(s / 86400)}d ago`;
}

export function ageHours(iso) {
  return (Date.now() - new Date(iso).getTime()) / 3600000;
}

export function daysLeft(iso) {
  if (!iso) return null;
  return Math.ceil((new Date(iso).getTime() - Date.now()) / 86400000);
}

export const TXN_LABELS = {
  deposit: "Deposit",
  deposit_bonus: "Deposit bonus",
  deposit_refund: "Deposit refund",
  bonus_reversal: "Bonus reversal",
  exchange_debit: "Exchange (sent)",
  exchange_credit: "Exchange (received)",
};

export const METHOD_TYPE_LABEL = { upi_qr: "UPI QR", payment_link: "Payment link" };

export function newRequestId() {
  if (window.crypto?.randomUUID) return window.crypto.randomUUID();
  return `${Date.now()}-${Math.random().toString(36).slice(2)}-${Math.random().toString(36).slice(2)}`;
}

export function downloadCSV(filename, rows) {
  if (!rows.length) return;
  const headers = Object.keys(rows[0]);
  const esc = (v) => `"${String(v ?? "").replace(/"/g, '""')}"`;
  const csv = [headers.join(","), ...rows.map((r) => headers.map((h) => esc(r[h])).join(","))].join("\n");
  const blob = new Blob([csv], { type: "text/csv;charset=utf-8" });
  const a = document.createElement("a");
  a.href = URL.createObjectURL(blob);
  a.download = filename;
  a.click();
  URL.revokeObjectURL(a.href);
}
